import {
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  Stack,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import axios from "axios";
import RightDrawer from "components/rightDrawer/RightDrawer";
import SetupCC from "components/setupCC";
import Editor from "components/ui/editor/Editor";
import InputField from "components/ui/inputField";
import MultiSelect from "components/ui/multiSelect";
import Select from "components/ui/select";
import useApi from "hooks/useApi";
import useFormatter from "hooks/useFormatter";
import moment from "moment";
import { useEffect, useState } from "react";
import * as yup from "yup";

export function removeTagsAndWhitespace(html) {
  const cleanr = /<\/?[^>]+>|\s+/gi;
  const plainText = html?.replace(cleanr, " ");
  return plainText?.trim();
}

const DetailRow = ({ label, value }) => (
  <Stack direction="row" spacing={1} alignItems="flex-start">
    <Typography sx={{ minWidth: "120px", fontWeight: 600 }}>
      {label}:
    </Typography>
    <Typography sx={{ wordBreak: "break-word" }}>{value || "-"}</Typography>
  </Stack>
);

const isStatusActive = (status) =>
  status === "active" || status === 1 || status === true;

const ClientNotice = () => {
  const { formatDate } = useFormatter();
  const { fetchData } = useApi();
  const username = "admin";
  const password = "password";
  const [customers, setCustomers] = useState([]);
  const [openDetails, setOpenDetails] = useState(false);
  const [detailData, setDetailData] = useState(null);

  const handleChangeStatus = async (id, status, setAllData) => {
    const result = await fetchData({
      method: "post",
      url: `/api/admin/client-notice/change-status/${id}`,
      data: {
        status,
      },
    });

    if (result?.success) {
      setAllData((allData) =>
        allData?.map((singleData) =>
          singleData.id === id ? { ...singleData, status } : singleData,
        ),
      );
    }
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        // const loginResponse = await axios.post(
        //   "https://sveducrm.com/api/path/login",
        //   { username, password },
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //   },
        // );

        // const loginData = loginResponse.data;
        // console.log("login response:", loginData);

        const configResponse = await axios.get(
          "https://sveducrm.com/api/path/get-config",
          {
            headers: {
              username,
              password,
            },
          },
        );

        const allCustomers = Array.isArray(configResponse?.data?.data)
          ? configResponse.data.data
          : [];
        setCustomers(
          allCustomers
            .map((item) => ({
              name: item?.name?.trim(),
              domain: item?.domain?.trim().replace(/^https?:\/\//i, ""),
            }))
            .filter((item) => item?.name && item?.domain),
        );
      } catch (error) {
        console.error("external api request failed:", error?.response || error);
      }
    };

    fetchConfig();
  }, []);

  const initialValues = {
    title: "",
    description: "",
    is_specific: 0,
    customer_data: [],
    user_type: "All",
    status: "inactive",
  };

  const customerOptions = customers.map((item) => ({
    ...item,
    id: item.domain,
    label: `${item.name} (${item.domain})`,
  }));

  const handleViewDetails = (row) => {
    setDetailData(row);
    setOpenDetails(true);
  };

  const formatDateAndTime = (value) => {
    if (!value || !moment(value).isValid()) return "-";
    return `${formatDate(value)} ${moment(value).format("hh:mm A")}`;
  };

  return (
    <>
      <SetupCC
        shouldReload
        sidebarWidth="700px"
        name="Client Notice"
        baseRouteKey="client-notice"
        moduleKey="client-notice"
        columns={[
          { id: "title", label: "Title", minWidth: 100 },
          { id: "description", label: "Description", width: "180px" },
          {
            id: "status",
            label: "Active/Inactive",
            style: { width: "100px" },
            align: "center",
          },
          { id: "created_at", label: "Created At", minWidth: 170 },
          { id: "updated_at", label: "Updated At", minWidth: 170 },
          {
            id: "action",
            label: "Actions",
            style: { width: "150px" },
            align: "center",
          },
        ]}
        conditionalColumns={(row, column, value, setAllData) => {
          return (
            <>
              {column?.id === "description" ? (
                <Typography
                  className={"clamped-text"}
                  variant="body2"
                  sx={{ width: "180px" }}
                  dangerouslySetInnerHTML={{
                    __html: removeTagsAndWhitespace(value),
                  }}
                ></Typography>
              ) : column?.id === "status" ? (
                <Tooltip
                  title={
                    <Typography
                      sx={{ textTransform: "capitalize", fontSize: "12px" }}
                    >
                      {isStatusActive(value) ? "Active" : "Inactive"}
                    </Typography>
                  }
                >
                  <FormControlLabel
                    control={<Switch />}
                    checked={isStatusActive(value)}
                    onChange={(e) =>
                      handleChangeStatus(
                        row?.id,
                        e.target.checked ? "active" : "inactive",
                        setAllData,
                      )
                    }
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#27ae61",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        {
                          backgroundColor: "#27ae61",
                        },
                    }}
                  />
                </Tooltip>
              ) : ["created_at", "updated_at"].includes(column?.id) ? (
                <Typography variant="body2">
                  {formatDateAndTime(value)}
                </Typography>
              ) : (
                value
              )}
            </>
          );
        }}
        actions={["view", "edit", "delete"]}
        onView={handleViewDetails}
        getInitialValues={(data) => {
          if (data?.id) {
            let obj = {};
            for (const key in initialValues) {
              obj[key] = data[key];
            }
            if (typeof obj.customer_data === "string") {
              try {
                obj.customer_data = JSON.parse(obj.customer_data);
              } catch {
                obj.customer_data = [];
              }
            }
            if (!Array.isArray(obj.customer_data)) {
              obj.customer_data = [];
            }
            return obj;
          } else return initialValues;
        }}
        validationSchema={yup.object({
          title: yup.string().required("Title is required!"),
          description: yup
            .string()
            .test("name-validation", "Description is required!", (value) =>
              Boolean(removeTagsAndWhitespace(value)),
            )
            .required("Description is required!"),
          user_type: yup
            .string()
            .oneOf(["All", "Admin", "Staff"])
            .required("User type is required!"),
          customer_data: yup.array().when("is_specific", {
            is: 1,
            then: (schema) =>
              schema.min(1, "At least one customer is required!"),
            otherwise: (schema) => schema,
          }),
          status: yup
            .string()
            .oneOf(["active", "inactive"])
            .required("Status is required!"),
        })}
        allFields={(formik) => (
          <>
            <InputField name="title" label="Title *" formik={formik} />
            <Editor formik={formik} name="description" standard />
            <Select
              name="user_type"
              label="User Type *"
              formik={formik}
              options={["All", "Admin", "Staff"]}
            />
            <FormControlLabel
              control={<Checkbox />}
              label="Specific Clients"
              checked={Number(formik.values.is_specific) === 1}
              onChange={(e) => {
                const checked = e.target.checked;
                formik.setFieldValue("is_specific", checked ? 1 : 0);
                if (!checked) {
                  formik.setFieldValue("customer_data", []);
                }
              }}
            />
            {Number(formik.values.is_specific) === 1 && (
              <>
                <MultiSelect
                  label="Clients *"
                  options={customerOptions}
                  value={(formik.values.customer_data || []).map(
                    (item) => item?.domain,
                  )}
                  onChange={(selectedDomains) => {
                    formik.setFieldTouched("customer_data", true, true);
                    const selectedCustomers = customerOptions
                      .filter((item) => selectedDomains.includes(item.domain))
                      .map((item) => ({
                        name: item.name,
                        domain: item.domain,
                      }));

                    formik.setFieldValue("customer_data", selectedCustomers);
                  }}
                  selectProps={{ id: "id", label: "label" }}
                />
                {formik.touched.customer_data &&
                  formik.errors.customer_data && (
                    <Typography color="error" variant="caption">
                      {formik.errors.customer_data}
                    </Typography>
                  )}
              </>
            )}

            <Select
              name="status"
              label="Status *"
              formik={formik}
              options={[
                { label: "Active", id: "active" },
                { label: "Inactive", id: "inactive" },
              ]}
            />
          </>
        )}
      ></SetupCC>

      <RightDrawer
        openDrawer={openDetails}
        setOpenDrawer={setOpenDetails}
        width="700px"
        headingLeft="Client Notice Details"
        headingRight=""
      >
        <Box p="20px">
          {detailData ? (
            <Stack spacing={2}>
              <DetailRow label="Title" value={detailData?.title} />
              <DetailRow label="User Type" value={detailData?.user_type} />
              <DetailRow
                label="Specific"
                value={detailData?.is_specific ? "Yes" : "No"}
              />
              <DetailRow
                label="Created At"
                value={formatDateAndTime(detailData?.created_at)}
              />
              <DetailRow
                label="Updated At"
                value={formatDateAndTime(detailData?.updated_at)}
              />

              <Stack spacing={1}>
                <Typography sx={{ fontWeight: 600 }}>Clients:</Typography>
                {Array.isArray(detailData?.customer_data) &&
                detailData.customer_data.length ? (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {detailData.customer_data.map((client) => (
                      <Chip
                        key={`${client?.name}-${client?.domain}`}
                        size="small"
                        label={`${client?.name} (${client?.domain})`}
                      />
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2">All Clients</Typography>
                )}
              </Stack>

              <Stack spacing={1}>
                <Typography sx={{ fontWeight: 600 }}>Description:</Typography>
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{
                    __html: detailData?.description || "-",
                  }}
                />
              </Stack>
            </Stack>
          ) : null}
        </Box>
      </RightDrawer>
    </>
  );
};

export default ClientNotice;
